<template>
<div class="chapter">
<div class="inner_page">
<div id="p1">
<hr style="height:.01em; margin-top: 0%; margin-bottom: .8em; margin-left: 22%; margin-right: 22%; background-color: #000000"/>
<p class="head">PART ONE</p>
<hr style="height:.01em; margin-top: .8em; margin-bottom: 0%; margin-left: 22%; margin-right: 22%; background-color: #000000"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part_1.vue?479702d2